module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [(_vm.title) ? _c('h2', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._l((_vm.revisions), function(revision) {
    return _c('div', {
      staticClass: "revision"
    }, [(_vm.revisions.length > 1) ? _c('h4', {
      staticClass: "tag revision__title"
    }, [_vm._v(_vm._s(revision.title))]) : _vm._e(), _c('p', {
      staticClass: "revision__container submission submission--answer"
    }, [_vm._v(_vm._s(revision.submission))])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2148f159","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/assignment/presenters/Question.vue
// module id = 4dtJ
// module chunks = 0 1